import React, { type FC, type PropsWithChildren } from 'react';

import Heading from '../../heading/heading';
import Box from '../../box/box';
import Link from '../../link/link';
import Wave from '../../wave/wave';
import type { Lucid } from '../../../types/types';

export interface WaveCtaProps {
  /** Allows the component to get additional styles. */
  className?: string;
  cta?: Lucid.Directus.Generated.Links | null;
  heading: string;
}

const WaveCta: FC<PropsWithChildren<WaveCtaProps>> = ({ className, cta, heading, ...rest }) => (
  <Wave {...rest} className={className}>
    <Box
      css={theme => ({
        label: 'waveCTA',
        textAlign: 'center',
        padding: `${theme.space.s0} ${theme.space.s4}px`,
        [theme.breakpoints.bp900.min]: {
          paddingBottom: theme.space.s48,
        },
      })}
    >
      <Heading
        as="h3"
        css={theme => ({ color: theme.colors.white, marginBottom: theme.space.s40 })}
        variant="headingXL"
      >
        {heading}
      </Heading>
      {cta && (
        <Link displayAsButton css={{ boxShadow: 'none' }} href={cta?.final_url!} variant="secondary">
          {cta?.default_link_text!}
        </Link>
      )}
    </Box>
  </Wave>
);

export default WaveCta;
